import { render, staticRenderFns } from "./UM_setUserReward.vue?vue&type=template&id=2a1ec0f4&scoped=true&"
import script from "./UM_setUserReward.vue?vue&type=script&lang=js&"
export * from "./UM_setUserReward.vue?vue&type=script&lang=js&"
import style0 from "./UM_setUserReward.vue?vue&type=style&index=0&id=2a1ec0f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1ec0f4",
  null
  
)

export default component.exports